define([], function () {
    "use strict";

    //viewModel: {title: "title", hide: false}
    function Step(containerID, viewModel, type) {
        this.containerID = containerID;
        this.viewModel = [];
        this.suffix = Math.floor(Math.random() * 1000);  // suffix for id attributes
        this.type = type ? type : "all"; //默认全部显示，移动端的type为single

        for (var i = 0; i < viewModel.length; i++) {
            this.viewModel.push({
                title: viewModel[i].title,
                imgClz: viewModel[i].imgClz,
                imgClzHL: viewModel[i].imgClzHL,
                imgClzCur: viewModel[i].imgClz,
                show: this.type === "all" || !viewModel[i].hide,
                ID: "step-" + (i + 1) + "-" + this.suffix,
                numID: "stepNum" + (i + 1) + "-" + this.suffix,
                numClass: "sm-stepNum " + (i === 0 ? "sm-selectedStepNum" : ""),
                titleID: "stepTitle" + (i + 1) + "-" + this.suffix,
                titleClass: "sm-stepTitle " + (i === 0 ? "sm-selectedStepTitle" : ""),
                nextShow: false
            });
        }

        this.stepCallback = $.Callbacks();
    }

    Step.prototype.template = '<div id="{{ stepView.ID }}" wt ng-show="stepView.show" ng-repeat="stepView in viewModel">' +
        '<span id="{{stepView.numID}}" class="{{stepView.imgClzCur}}"></span>' +
        '<span id="{{stepView.titleID}}" class="{{stepView.titleClass}}" ng-bind="stepView.title"></span>' +
        '<span class="simple-next" ng-show="stepView.nextShow">&gt;&gt;</span>' +
        '</div>';

    Step.prototype.render = function ($scope, $compile) {
        var template = this.template;;
        var link = $compile(template);
        var scope = $scope.$new(false);
        scope.viewModel = this.viewModel;
        scope.type = this.type;
        var node = link(scope);
        $("#" + this.containerID).html(node);
        this.scope = scope;
    };

    //for setTimeout use
    Step.prototype.refresh = function () {
        try {
            this.scope.$digest();
        } catch (e) {

        }
    };

    Step.prototype.goToStep = function (step, args) {
        if (step > this.viewModel.length) {
            return;
        }
        step--;

        var stepNum = "sm-stepNum";
        var selectedNum = "sm-stepNum selectedStepNum";
        var stepTitle = "sm-stepTitle";
        var selectedTitle = "sm-stepTitle selectedStepTitle";

        for (var i = 0; i < this.viewModel.length; i++) {
            if (i <= step) {
                this.viewModel[i].numClass = selectedNum;
                this.viewModel[i].titleClass = selectedTitle;
                this.viewModel[i].imgClzCur = this.viewModel[i].imgClz + ' ' + this.viewModel[i].imgClzHL;
            } else {
                this.viewModel[i].numClass = stepNum;
                this.viewModel[i].titleClass = stepTitle;
                this.viewModel[i].imgClzCur = this.viewModel[i].imgClz;
            }
            this.viewModel[i].show = this.type === "all" ? true : i === step
            
            if(i==this.viewModel.length-1){
            	this.viewModel[i].nextShow = false;
            }else{
            	this.viewModel[i].nextShow = true;
            }
        }
        this.refresh();
        this.stepCallback.fire(step + 1, args);
    };

    Step.prototype.onStepChange = function (stepCallbacks) {
        this.stepCallback.add(stepCallbacks);
    };

    return Step;
});


// WEBPACK FOOTER //
// ./public/base/widgets/step/step-simple.js